import { Quote as QuoteIcon } from "lucide-react";
import { SectionHead } from "@/components/SectionHead";
import { useLang } from "@/LanguageContext";
import { TESTIMONIALS, PHONE_TEL } from "@/data/site";

export const Testimonials = () => {
  const { t } = useLang();
  return (
  <section data-testid="testimonials-section" className="border-b border-steel-700 py-20 md:py-32">
    <div className="mx-auto max-w-[1400px] px-4 md:px-8 lg:px-12">
      <SectionHead
        label={t.testimonials.label}
        title={t.testimonials.title}
        sub={t.testimonials.sub}
        testid="testimonials-head"
      />
      <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
        {TESTIMONIALS.map((item, i) => (
          <figure
            key={i}
            data-testid={`testimonial-${i}`}
            className="relative rounded-sm border border-dashed border-steel-700 bg-steel-900 p-7 transition-colors duration-300 hover:border-forge"
          >
            <QuoteIcon size={26} className="text-forge" />
            <blockquote className="mt-4 text-base leading-relaxed text-steel-400">“{t.testimonials.quote}”</blockquote>
            <figcaption className="mt-6 border-t border-steel-800 pt-4 font-head text-lg font-bold uppercase tracking-wide text-steel-50">
              {t.testimonials.name}
              <span className="block font-mono text-[11px] font-normal normal-case tracking-[0.14em] text-steel-400">
                {item.town}
              </span>
            </figcaption>
          </figure>
        ))}
      </div>
      <a
        href={`sms:${PHONE_TEL}`}
        data-testid="leave-review-btn"
        className="mt-8 inline-block rounded-sm border border-steel-700 px-6 py-3 font-head text-base font-bold uppercase tracking-wide text-steel-50 transition-colors duration-200 hover:border-forge hover:text-forge-light"
      >
        {t.testimonials.cta}
      </a>
    </div>
  </section>
  );
};
